import { useTranslation } from "react-i18next";
import { CollapsibleSection } from "components/designV2/collapsibleSection/collapsibleSection";
import { type CompanyGigApplications } from "model/Gig";
import {
  ApplicationsList,
  EmployeesCountText,
} from "./teamPublicDetailsModal.styled";
import { TeamPublicDetailsModalApplicationRow } from "./teamPublicDetailsModal.applicationRow.component";
import { getApplicationWorkerExternalId } from "./teamPublicDetailsModal.mapper";
import { DetailsMessage } from "../shiftDetailsModal.styled";

interface TeamPublicDetailsModalEmployeesSectionProps {
  readonly hiredApplications: ReadonlyArray<CompanyGigApplications>;
  readonly amountOfWorkers: number;
  readonly avatarUrls: Record<string, string>;
  readonly isPublicShift: boolean;
  readonly onOpenMotivationalLetterModal: (motivationalLetter: string) => void;
}

export const TeamPublicDetailsModalEmployeesSection: React.FC<
  TeamPublicDetailsModalEmployeesSectionProps
> = (props) => {
  const { t } = useTranslation();
  const hiredCount = props.hiredApplications.length;
  const hasHiredApplications = hiredCount > 0;
  const safeAmountOfWorkers = Number.isFinite(props.amountOfWorkers)
    ? Math.max(0, props.amountOfWorkers)
    : 0;

  return (
    <CollapsibleSection
      label={t("Schedule.TeamPublicEmployees")}
      defaultOpen={hasHiredApplications}
      headerRight={
        <EmployeesCountText>{`(${hiredCount}/${safeAmountOfWorkers})`}</EmployeesCountText>
      }
    >
      {!hasHiredApplications ? (
        <DetailsMessage>{t("Schedule.TeamPublicNoEmployees")}</DetailsMessage>
      ) : (
        <ApplicationsList>
          {props.hiredApplications.map((application) => (
            <TeamPublicDetailsModalApplicationRow
              key={`hired-${application.id}`}
              application={application}
              avatarUrl={
                props.avatarUrls[getApplicationWorkerExternalId(application)]
              }
              isPublicShift={props.isPublicShift}
              isBusy={false}
              canManageApplication={false}
              onOpenMotivationalLetterModal={
                props.onOpenMotivationalLetterModal
              }
            />
          ))}
        </ApplicationsList>
      )}
    </CollapsibleSection>
  );
};
